"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.notify.done': 'Dziękuję za stworzenie mnie. Powiedz mi, jak mogę ci pomóc.',
};
